export default "__VITE_ASSET__65c566a4__"